// @flow
import * as React from "react"
import type { HOC } from "recompose"
import withQuery from "hoc/withQuery"
import {
  isLateForReturn,
  isTodayForReturn,
  isLateForPickup,
  isTodayForPickup,
  STATES,
} from "data/reservations/helpers"
import type { Reservation } from "data/reservations/types"
import { affiliateCurrentDate } from "data/affiliate/graphql"
import type { DateString } from "data/units/date/types"
import { WarningWrap } from "./styled"

type Props = {|
  reservation: Reservation,
  data: {affiliateCurrentDate: DateString},
|}

const Warning = ({ reservation, data }: Props) => {
  const date = data.affiliateCurrentDate

  if (isLateForReturn(reservation, date)) {
    return (
      <WarningWrap nomargin error>
        {STATES.lateForReturn}
      </WarningWrap>
    )
  }

  if (isLateForPickup(reservation, date)) {
    return (
      <WarningWrap nomargin error>
        {STATES.lateForPickup}
      </WarningWrap>
    )
  }

  if (isTodayForReturn(reservation, date)) {
    return (
      <WarningWrap nomargin>
        {STATES.returnToday}
      </WarningWrap>
    )
  }

  if (isTodayForPickup(reservation, date)) {
    return (
      <WarningWrap nomargin>
        {STATES.pickupToday}
      </WarningWrap>
    )
  }

  return null
}

type Outter = {|
  reservation: Reservation,
|}

const enhancer: HOC<*, Outter> = withQuery(affiliateCurrentDate, {
  noEmpty: true,
  variables: props => ({
    affiliateId: props.reservation.productItem.affiliate.id,
  }),
  noLoader: true,
})

export default enhancer(Warning)



// WEBPACK FOOTER //
// ./src/components/ReservationList/ReservationTile/Warning/index.js